// @flow

import React, { Component } from 'react';
import type { ComponentType } from 'react';
import { required as requiredValidator } from '../../../helpers/formValidators';

export type RequiredProps = {
  required?: boolean,
  requiredError?: string,
  validate?: Array<Function>,
};

const withRequired = <Props: {}>(
  WrappedComponent: ComponentType<Props>,
): ComponentType<Props & RequiredProps> => (
    class WithRequired extends Component<Props & RequiredProps> {
      validators: Array<Function>;

      static defaultProps = {
        required: false,
        requiredError: '',
        validate: [],
      };

      constructor(props) {
        super(props);

        const { required, validate, requiredError } = props;
        this.validators = [...validate];
        if (required) {
          this.validators.push(requiredValidator(requiredError || ''));
        }
      }

      render() {
        const {
          required,
          requiredError,
          validate,
          ...otherProps
        } = this.props;

        return (
          <WrappedComponent
            validate={this.validators.filter(val => val !== undefined)}
            {...otherProps}
          />
        );
      }
    }
  );

export default withRequired;
